import React, { useContext } from "react";
import Box from "@mui/material/Box";

import { Grid } from "@mui/material";
import CelebrityItem from "./CelebrityItem";
import { TheContext } from "../Context";

export default function CelebrityList() {
  const { celebrities } = useContext(TheContext);
  return (
    <Grid
      container
      spacing={0}
      flex
      sx={{
        margin: "auto",
      }}
      xs={12}
      md={6}
    >
      <Box>
        {celebrities.map((celeb) => {
          return <CelebrityItem key={celeb.id} celeb={celeb} />;
        })}
      </Box>
    </Grid>
  );
}
